module.exports = __webpack_public_path__ + "static/projectMetaMask-0ec09408aa1bf5e19a6e1a87d3f2b0e1.svg";